import interceptorAxios from './InterceptorAxios';
const ServicioRetenciones = {
    buscarLista(objeto){
        return interceptorAxios.post('retencion/lista.json',objeto);
    }
}
export default ServicioRetenciones;